import AdminConfig from './admin';

import ClientView from './TableModule';


export default {
  name : 'table',

  type : 'module',
  
  label: 'tableau',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-table-large',
  }
}